import { render } from "./Split.vue?vue&type=template&id=9b3bd974&scoped=true&ts=true"
import script from "./splitHelper.ts?vue&type=script&lang=ts"
export * from "./splitHelper.ts?vue&type=script&lang=ts"

import "./Split.vue?vue&type=style&index=0&id=9b3bd974&scoped=true&lang=scss"

import exportComponent from "D:\\softwhere\\tools\\tools\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b3bd974"]])

export default __exports__